import { render, staticRenderFns } from "./PreProjectsSamplePreview.vue?vue&type=template&id=0995dea4&scoped=true"
import script from "./PreProjectsSamplePreview.vue?vue&type=script&lang=js"
export * from "./PreProjectsSamplePreview.vue?vue&type=script&lang=js"
import style0 from "./PreProjectsSamplePreview.vue?vue&type=style&index=0&id=0995dea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0995dea4",
  null
  
)

export default component.exports